import { createContext, useContext } from 'react';

export const PageIsMobileCtx = createContext(null);
export const PageScrollUpCtx = createContext(null);
export const PageYOffsetCtx = createContext(null);

export const usePageIsMobile = () => useContext(PageIsMobileCtx);
export const usePageScrollUp = () => useContext(PageScrollUpCtx);
export const usePageYOffset = () => useContext(PageYOffsetCtx);
